__turbopack_context__.v({
  "container": "BottomBar-module__Z2yORa__container",
  "ctaContainer": "BottomBar-module__Z2yORa__ctaContainer",
  "divider": "BottomBar-module__Z2yORa__divider",
  "editTripButton": "BottomBar-module__Z2yORa__editTripButton",
  "infoBar": "BottomBar-module__Z2yORa__infoBar",
  "noButtonContainer": "BottomBar-module__Z2yORa__noButtonContainer",
  "nonBreaking": "BottomBar-module__Z2yORa__nonBreaking",
  "origin": "BottomBar-module__Z2yORa__origin",
  "originButton": "BottomBar-module__Z2yORa__originButton",
});
